import { IconPropsType } from '..';

export const TelegramOutlinedIcon = ({ ...props }: IconPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    {...props}
  >
    <path
      d="M20.7117 41C31.7574 41 40.7117 32.0457 40.7117 21C40.7117 9.95431 31.7574 1 20.7117 1C9.66597 1 0.71167 9.95431 0.71167 21C0.71167 32.0457 9.66597 41 20.7117 41Z"
      stroke="url(#paint0_linear_87_5673)"
      strokeWidth="1.05152"
      strokeMiterlimit="10"
    />
    <path
      d="M16.5213 29.2279C16.3163 29.2279 16.1218 29.1017 16.0481 28.8966L13.9293 23.1816C13.8347 22.9187 13.9661 22.6296 14.229 22.5297C14.4919 22.435 14.7811 22.5665 14.881 22.8293L16.9998 28.5444C17.0944 28.8073 16.963 29.0964 16.7001 29.1963C16.6423 29.2174 16.5844 29.2279 16.5266 29.2279H16.5213Z"
      fill="#00B0E7"
    />
    <path
      d="M16.553 29.2909C16.4794 29.2909 16.4005 29.2751 16.3322 29.2383C16.1534 29.149 16.0378 28.9597 16.0483 28.7599L16.2586 24.0438C16.2691 23.8545 16.3795 23.6863 16.5477 23.6074C16.716 23.5286 16.921 23.5496 17.0682 23.66L19.8916 25.8051C20.0125 25.8997 20.0861 26.0417 20.0914 26.1942C20.0914 26.3466 20.0283 26.4939 19.9126 26.5938L16.879 29.17C16.7843 29.2488 16.6687 29.2909 16.553 29.2909ZM17.226 25.0533L17.1103 27.6453L18.777 26.231L17.226 25.0533Z"
      fill="#00B0E7"
    />
    <path
      d="M24.5237 30.1376C24.1399 30.1376 23.7666 30.0114 23.4511 29.7748L16.4585 24.4699C16.3375 24.3805 16.2639 24.2385 16.2587 24.0861C16.2587 23.9336 16.3165 23.7864 16.4322 23.6865L21.1588 19.5435L14.6709 23.4446C14.5447 23.5235 14.387 23.5393 14.2503 23.492L9.2713 21.8095C8.81389 21.657 8.51421 21.2417 8.5037 20.7632C8.49318 20.2795 8.78234 19.8589 9.22924 19.6854L28.5352 12.351C28.9296 12.1986 29.3712 12.2827 29.6867 12.5613C30.0021 12.84 30.1336 13.2711 30.0337 13.6812L26.2534 28.7969C26.1062 29.3805 25.6856 29.8432 25.1178 30.0429C24.9233 30.1113 24.7235 30.1428 24.5237 30.1428V30.1376ZM17.5678 24.0387L24.0663 28.9704C24.2766 29.1281 24.5342 29.1702 24.7813 29.0808C25.0284 28.9914 25.2072 28.7969 25.2703 28.5445L29.0505 13.4289C29.0663 13.371 29.04 13.3342 29.0137 13.3132C28.9927 13.2922 28.9506 13.2711 28.898 13.2922L9.59202 20.6265C9.59202 20.6265 9.51841 20.6581 9.51841 20.737C9.51841 20.8158 9.57624 20.8368 9.59727 20.8421L14.3554 22.4509L25.4911 15.7632C25.7172 15.6265 26.0063 15.6896 26.1588 15.8999C26.3113 16.1102 26.2797 16.4047 26.0852 16.5782L17.5731 24.0387H17.5678Z"
      fill="#00B0E7"
    />
    <defs>
      <linearGradient
        id="paint0_linear_87_5673"
        x1="6.19537"
        y1="6.48896"
        x2="35.2227"
        y2="35.5163"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B0E7" />
        <stop
          offset="1"
          stopColor="#0094D6"
        />
      </linearGradient>
    </defs>
  </svg>
);
